<template>
  <teleport to="body">
    <transition name="cdm-fade">
      <div
        v-if="modelValue"
        class="cdm-backdrop"
        @click.self="cancel"
      >
        <transition name="cdm-scale" appear>
          <div class="cdm-modal">

            <!-- Icon -->
            <div class="cdm-icon">
              <i class="fa fa-trash"></i>
            </div>

            <!-- Title -->
            <h6 class="cdm-title">{{ title }}</h6>

            <!-- Message -->
            <p class="cdm-msg">
              {{ message }}
              <template v-if="itemName">
                <strong class="cdm-item">{{ itemName }}</strong>
              </template>
            </p>
            <span class="cdm-sub">This action cannot be undone.</span>

            <!-- Actions -->
            <div class="cdm-actions">
              <button class="cdm-btn cdm-btn-cancel" :disabled="loading" @click="cancel">
                Cancel
              </button>
              <button class="cdm-btn cdm-btn-danger hover-white" :disabled="loading" @click="confirm">
                <i v-if="loading" class="fa fa-spinner fa-spin"></i>
                <i v-else class="fa fa-trash"></i>
                {{ loading ? 'Deleting...' : confirmText }}
              </button>
            </div>

          </div>
        </transition>
      </div>
    </transition>
  </teleport>
</template>

<script>
export default {
  name: 'ConfirmDeleteModal',

  emits: ['update:modelValue', 'confirm', 'cancel'],

  props: {
    modelValue: { type: Boolean, default: false },
    title: { type: String, default: 'Confirm Delete' },
    message: { type: String, default: 'Are you sure you want to delete' },
    itemName: { type: String, default: '' },
    confirmText: { type: String, default: 'Yes, Delete' },
    loading: { type: Boolean, default: false },
  },

  methods: {
    confirm() {
      this.$emit('confirm')
    },
    cancel() {
      this.$emit('update:modelValue', false)
      this.$emit('cancel')
    },
  },
}
</script>
<style scoped>
.cdm-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 15, 20, 0.4);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1070;
}

.cdm-modal {
  --pp-accent: #4642c9;
    --pp-accent-hover: #3a37a8;
    --pp-accent-soft: #f0f0fb;
    background: #fff;
    border-radius: 12px;
    width: 402px;
   max-width: calc(100vw - 32px); 
    box-shadow: 0 10px 30px -5px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.04);
    padding: 24px 31px 27px;
    text-align: center;
}

.cdm-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: var(--pp-accent-soft);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 14px;
  font-size: 16px;
  color: var(--pp-accent);
}

.cdm-title {
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 6px;
}

.cdm-msg {
  font-size: 13px;
  color: #6b7280;
  line-height: 1.5;
  margin-bottom: 2px;
}

.cdm-item {
  display: block;
  color: #1a1a1a;
  font-weight: 600;
  margin-top: 2px;
}

.cdm-sub {
  display: block;
  font-size: 11.5px;
  color: #9ca3af;
  margin-bottom: 18px;
}

.cdm-actions {
  display: flex;
  justify-content: center;
  gap: 8px;
}

.cdm-btn {
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 8px;
  font-size: 12.5px;
  font-weight: 600;
  border: 1px solid transparent;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease, opacity 0.15s ease;
}

.cdm-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.cdm-btn-cancel {
  background: #fff;
  border-color: #e5e7eb;
  color: #4b5563;
}

.cdm-btn-cancel:hover:not(:disabled) {
  background: #f9fafb;
  border-color: #d1d5db;
}

.cdm-btn-danger {
  background: var(--pp-accent);
  color: #fff;
}

.cdm-btn-danger:hover:not(:disabled) {
  background: var(--pp-accent-hover);
}

/* Transitions */
.cdm-fade-enter-active,
.cdm-fade-leave-active {
  transition: opacity 0.15s ease;
}
.cdm-fade-enter-from,
.cdm-fade-leave-to {
  opacity: 0;
}

.cdm-scale-enter-active {
  transition: transform 0.18s cubic-bezier(0.34, 1.56, 0.64, 1), opacity 0.15s ease;
}
.cdm-scale-enter-from {
  transform: scale(0.94);
  opacity: 0;
}
</style>